export default __webpack_public_path__ + "static/media/kitchen3-afterA-768w.8e8e3145.png";